import Domain from '../domain';
import Predict from '../predict';
import WapiDvariant from '../WapiDvariant';
import PredictRange from '../predictrange';
import { toParameterLayersViewModel } from './parameters';

export function toDomainsViewModel(domains, predictRanges, contract, predicts, parameters) {
  const result = domains.map(x => {
    const domain = new Domain();
    domain.id = x.id;
    domain.name = x.name;
    domain.checked = false;
    domain.checkedAll = false;
    domain.predicts = [];

    const dvariant = contract.forecast_settings.dvariants.find(d => d.domain == x.name);
    const domainContractParameters = dvariant ?.parameters;

    const domainParameters = parameters.find(d => d.domain == x.name);

    domain.is_interpolate_preset = dvariant ?.is_interpolate_preset || false;
    domain.is_interpolate_point = dvariant ?.is_interpolate_point || false;

    domain.parameterLayersViewModel = toParameterLayersViewModel(domainParameters.parameters, domainContractParameters || []);    

    return domain;
  });

  result.forEach(d => {
    const currentPredict = predicts.find(x => x.domain_name === d.name);
    const arr = currentPredict?.predicts || [];

    const dgroup = contract.forecast_settings.dvariants.find(m => m.domain === d.name);
    let checked = [];
    if (dgroup) {
      checked = dgroup.predicts;
      d.checked = true;
      d.prioritet = String(dgroup.prioritet);
    }
    else {
      d.prioritet = "1";
    }

    const predictValues = arr.map(x => {
      const predict = new Predict();
      predict.value = x;
      predict.checked = checked.includes(x);
      return predict;
    });

    checked.forEach(x => {
      if (!predictValues.find(r => r.value === x)) {
        const predict = new Predict();
        predict.value = x;
        predict.checked = true;
        predictValues.push(predict);
      }
    });

    predictValues.sort((a, b) => a.value - b.value);

    d.predicts = predictValues;    
    d.predictRanges = predictRanges.map(            
      x =>
      {
        const pr = new PredictRange();        
        pr.from = x.from;
        pr.to = x.to;
        pr.predicts = d.predicts.filter(p => p.value >= x.from && p.value <= x.to);                

        return pr;
      }
    );

    d.predictRanges.forEach(x => {
      x.rangePredicts = x.predicts.map(x => x.value);
    });
  });

  return result;
}

export function toWapiDvariant(domainsViewModel) {
  const result = domainsViewModel.filter(x => x.checked).map(x => {
    const wapiDvariant = new WapiDvariant();
    wapiDvariant.domain = x.name;
    wapiDvariant.predicts = x.predicts.filter(p => p.checked).map(p => p.value);
    wapiDvariant.prioritet = parseInt(x.prioritet);
    wapiDvariant.is_interpolate_preset = x.is_interpolate_preset;
    wapiDvariant.is_interpolate_point = x.is_interpolate_point;
    wapiDvariant.parameters = x.parameterLayersViewModel.map(pl => pl.parameters.filter(p => p.checked)).flat().map(x => x.sname);

    return wapiDvariant;
  });

  return result;
}
